import { FC, useState } from "react";
import {
  Button,
  List,
  ListItem,
  ListItemText,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { AppbarWrapper, DrawerWrapper } from "./Appbar.style";
import { redirectToNewTab, redirectToUrl } from "utils/redirectToUrl";
import { MenuItem } from "./Appbar.types";
// import { Switch } from "components";
import { useStoreContext } from "context/storeContext";
import { MenuIcon } from "components";

const menuItems: MenuItem[] = [
  { label: "Download", url: process.env.REACT_APP_DOWNLOAD || "" },
  { label: "Docs", url: process.env.REACT_APP_DOCS || "" },
  { label: "Community", url: process.env.REACT_APP_COMMUNITY || "" },
  {
    label: "News & Events",
    url: process.env.REACT_APP_NEWS_AND_EVENTS || "",
  },
  { label: "About", url: process.env.REACT_APP_ABOUT || "" },
  { label: "Contact", url: process.env.REACT_APP_CONTACT || "" },
];

type IAppbarProps = {};

export const Appbar: FC<IAppbarProps> = () => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const {
    // actions: { setDarkMode },
    states: { darkMode },
  } = useStoreContext();

  const onClickHandler = (
    event: React.MouseEvent<HTMLButtonElement | HTMLDivElement, MouseEvent>,
    url: string,
  ) => {
    if (event.metaKey || event.ctrlKey) {
      const win = redirectToNewTab(url);
      win?.focus();
    } else {
      redirectToUrl(url);
    }
  };

  return (
    <AppbarWrapper
      className="appbar-container"
      data-testid="appbar"
      darkMode={darkMode}
    >
      <div className="appbar">
        <a className="logo-div" href={process.env.REACT_APP_QUANTLAB}>
          <img
            src={`/quantlab-function-library/icons/logo-${darkMode ? "white" : "black"}.svg`}
            alt="logo"
            color="inherit"
            className="logo"
          />
        </a>
        <div className="actions">
          {!isMobile &&
            menuItems.map((item, index) => (
              <Button
                key={index}
                color="inherit"
                onClick={(e) => onClickHandler(e, item.url)}
              >
                {item.label}
              </Button>
            ))}
          {/* {!isMobile && <Switch darkMode={darkMode} onToggle={(mode) => setDarkMode(mode)}/>} */}
        </div>
        {isMobile && (
          <div className="menu">
            <MenuIcon onClick={toggleDrawer} />
          </div>
        )}
      </div>
      <DrawerWrapper
        anchor="top"
        open={drawerOpen}
        onClose={toggleDrawer}
        BackdropProps={{ invisible: true }}
        darkMode
      >
        <List>
          {menuItems.map((item, index) => (
            <ListItem
              key={index}
              onClick={() => redirectToUrl(item.url)}
              sx={{ paddingTop: "0px" }}
            >
              <CustomListItemText
                primary={item.label}
                className="drawer-buttons"
                sx={{
                  "& .css-16tk02s-MuiTypography-root": { fontWeight: 500 },
                }}
              />
            </ListItem>
          ))}
          {/* <Switch darkMode={darkMode} onToggle={(mode) => setDarkMode(mode)}/> */}
        </List>
      </DrawerWrapper>
    </AppbarWrapper>
  );
};

const CustomListItemText = styled(ListItemText)({
  fontWeight: 500,
});
